export default {
    BPA_CONSOLIDADO: '01',
    BPA_INDIVIDUALIZADO: '02',
    APAC_PROCEDIMENTO_PRINCIPAL: '06',
    APAC_PROCEDIMENTO_SECUNDARIO: '07',
    RAAS_ATENCAO_PSICOSSOCIAL: '09',
}